export const shouldUseTypeBasedEntityApi = () => Boolean(globalThis.useTypeBasedApi && globalThis.productSuffix);

/**
 * Returns the path/query identifier for entity routes and type-based API calls.
 * Legacy mode uses entity.id; type-based mode uses entity.type (falls back to id when type is null).
 */
export const getEntityRouteParam = entity => {
  if (!entity) return undefined;
  if (shouldUseTypeBasedEntityApi() && entity.type != null) {
    return entity.type;
  }
  return entity.id;
};

/** Wraps getEntityRouteParam for service methods that expect `{ id }` (mapArgs renames to type in v2). */
export const getEntityServiceIds = entity => ({ id: getEntityRouteParam(entity) });

/** Route param from useParams is already the correct segment value for the active API mode. */
export const getEntityServiceIdsFromRouteParam = routeParam => ({ id: routeParam });

/** Display label for an entity: title-first when type-based API is active, name-first otherwise. */
export const getEntityDisplayLabel = entity => {
  if (!entity) return undefined;
  return shouldUseTypeBasedEntityApi() ? entity.title ?? entity.name : entity.name ?? entity.title;
};

/**
 * Id used to address a RELATIONSHIP field's target. A type-based native lookup stores the target's lego_id in
 * related_entity_id, so its datasource id (needed for choices search / field-resolutions) comes from
 * field_options.source_id; older fields without it fall back to related_entity_id.
 */
export const getRelationshipSourceId = field => {
  const options = field?.field_options;
  if (shouldUseTypeBasedEntityApi() && options?.related_object_type === 'NATIVE' && options.source_id !== undefined && options.source_id !== null) {
    return options.source_id;
  }
  return field?.related_entity_id;
};
